import { AccountType, IAccount } from "./account/IAccount";
import { IDocument } from "./Document";
import { BaseEntity, DefaultResponseWithData } from "./system";

export interface ISingleContactRespose
  extends DefaultResponseWithData<IContact> { }
export interface IAllContactsResponse
  extends DefaultResponseWithData<IContact[]> { }

export enum ContactType {
  Customer,
  Supplier,
  Staff,
  Driver,
  Admin,
  Mechanic,
  Exporter,
}

export interface IContact extends BaseEntity {
  contactType: ContactType;
  fullname: string;
  telephone1: string;
  telephone2: string;
  email: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  locality: string;
  town: string;
  county: string;
  postcode: string;
  notes: string;
  ebayUsername: string;

  deleted: string | null;

  accountId?: string;
  account: IAccount | null;

  documents: IDocument[];

  //Frontend only
  hasDocuments: boolean;
}

// A lead hanging off a contact. Widget leads are handed to us on a contact the widget has already
// deduplicated on email + phone, so one seller quoting several vehicles lands on a single contact
// row - editing it from one lead rewrites the details on all of them.
export interface IContactLeadSummary {
  id: string;
  vehicleId: string | null;
  vrm: string | null;
  make: string | null;
  model: string | null;
  status: number;
  website: number;
  price: number;
  applyVAT: boolean;
  created: string;
}

export interface ISplitContactRequest {
  leadId: string;
  // Edited details to apply to the new copy. Omit to copy the contact as it stands.
  contact?: Partial<IContact> | null;
}

export interface ContactCreateEditRequest
  extends Omit<
    IContact,
    "created" | "updated" | "deleted" | "ebayUsername" | "accountId"
  > {
  createAccountQuery?: boolean;
  accountName: string | null;
  bankAccountName: string | null;
  bankAccountNumber: string | null;
  bankSortCode: string | null;
  accountType: AccountType;

  createAccount?: boolean;
}

